/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_DescInputs */

const en_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable and disable email notifications.`)
};

const fr_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer et désactiver les notifications par email.`)
};

const de_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Benachrichtigungen aktivieren und deaktivieren.`)
};

const it_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita e disabilita le notifiche e-mail.`)
};

const ru_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включение и отключение уведомлений по электронной почте.`)
};

const es_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar y deshabilitar las notificaciones por correo electrónico.`)
};

const zh_cn2_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用和禁用电子邮件通知。`)
};

const ja_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子メール通知を有効または無効にします。`)
};

const hi_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल नोटिफिकेशन को चालू और बंद करें।`)
};

const pt_pt2_options_notifications_desc = /** @type {(inputs: Options_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar e desativar notificações por e-mail.`)
};

/**
* | output |
* | --- |
* | "Enable and disable email notifications." |
*
* @param {Options_Notifications_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_desc = /** @type {((inputs?: Options_Notifications_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_notifications_desc(inputs)
	if (locale === "de") return de_options_notifications_desc(inputs)
	if (locale === "it") return it_options_notifications_desc(inputs)
	if (locale === "ru") return ru_options_notifications_desc(inputs)
	if (locale === "es") return es_options_notifications_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_notifications_desc(inputs)
	if (locale === "ja") return ja_options_notifications_desc(inputs)
	if (locale === "hi") return hi_options_notifications_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_notifications_desc(inputs)
	return en_options_notifications_desc(inputs)
});